module.exports = __webpack_public_path__ + "img/amr.bf8c5411.png";